import MerchantApplication from './MerchantApplication';

export default MerchantApplication;
